"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOrders = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const clients_1 = require("../types/clients");
const generateOrders = (numberOfOrders, customerId, skuIds, clientId, lang = clients_1.LANGUAGE.en) => {
    const orderName = lang === clients_1.LANGUAGE.en
        ? `Order of products`
        : lang === clients_1.LANGUAGE.es
            ? `orden de productos`
            : `Commande de products`;
    const orders = Array.from({ length: numberOfOrders }, () => {
        const createdAt = en_1.faker.date.between({
            from: new Date(2024, 1, 1),
            to: new Date(),
        });
        const confirmedAt = createdAt;
        const orderStatus = en_1.faker.helpers.arrayElement(en_1.faker.helpers.shuffle(Object.values(types_1.OrderStatus)));
        const deliveredAt = en_1.faker.date.between({
            from: createdAt,
            to: new Date(),
        });
        const deliveredDueDate = orderStatus === types_1.OrderStatus.DELIVERED
            ? en_1.faker.date.between({
                from: deliveredAt,
                to: new Date(),
            })
            : en_1.faker.date.between({
                from: createdAt,
                to: new Date(),
            });
        const id = (0, tools_1.IDSource)();
        const order = Object.assign(Object.assign({ id, erp_id: `erp-id-${id}`, name: orderName, description: en_1.faker.word.words(4), client_id: clientId, customer_id: customerId, customer_name: `Customer ${customerId}`, customer_erp_id: `customer-erp-id-${customerId}`, tracking_id: (0, tools_1.generateUnique4DigitID)(), status: orderStatus, 
            // TODO: randomize amounts a bit more ?
            amounts: {
                gross_amount: 90 * skuIds.length,
                net_amount: 80 * skuIds.length,
                tax_amount: 20 * skuIds.length,
                discount_amount: 10 * skuIds.length,
            }, products_ordered: skuIds.map((skuId) => ({
                id: skuId,
                amounts: {
                    gross_amount: 90,
                    net_amount: 80,
                    tax_amount: 20,
                    discount_amount: 10,
                },
                quantity: en_1.faker.number.int({
                    min: 1,
                    max: 1000,
                }),
                price: en_1.faker.number.float({
                    min: 1,
                    max: 10000,
                    multipleOf: 2,
                }),
            })), created_at: createdAt }, (orderStatus === types_1.OrderStatus.DELIVERED && {
            delivered_at: deliveredAt,
        })), { delivered_at: deliveredAt, delivery_due_date: deliveredDueDate, confirmed_at: confirmedAt });
        return order;
    });
    return orders;
};
exports.generateOrders = generateOrders;
